import LineAmChart from './LineAmChart';

export default LineAmChart;
